import { redirect } from "react-router-dom";

import { accountsQuery } from "@/services/lukita/queries";

export default function authorizeLoader(loader) {
  return async (...args) => {
    const { accounts } = await accountsQuery();
    const account = accounts[0];

    if (account && !account.active) {
      return redirect("/");
    }

    if (!loader) return {};
    return loader(...args);
  };
}
